import {
    ACCOUNTS_FILTERS_SEARCH_ROLES_REQUEST,
    ACCOUNTS_FILTERS_SEARCH_ROLES_RESULT
} from 'Redux/actionTypes';

export const accountFiltersSearchRolesRequest = (data) => ({
    type: ACCOUNTS_FILTERS_SEARCH_ROLES_REQUEST,
    payload: data
})

export const accountFiltersSearchRolesResult = (result) => ({
    type: ACCOUNTS_FILTERS_SEARCH_ROLES_RESULT,
    payload: result
})